import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import SimpleMarkdown from 'simple-markdown';
import hljs from 'highlight.js';

import {Anchor} from '@albert-io/atomic';

const supportedLanguages = hljs.listLanguages();

class Code extends React.Component {
  static propTypes = {
    content: PropTypes.string,
    block: PropTypes.bool,
    language: PropTypes.string
  };

  render() {
    const className =
      this.props.language && supportedLanguages.includes(this.props.language)
        ? this.props.language
        : '';
    let content;
    const skipHighlighting = this.props.language === 'no-color';
    if (skipHighlighting) {
      content = this.props.content;
    } else if (className) {
      content = hljs.highlight(className, this.props.content).value;
    } else {
      content = hljs.highlightAuto(this.props.content).value;
    }
    if (this.props.block) {
      return (
        <pre>
          {/* eslint-disable react/no-danger-with-children */}
          {/* eslint-disable react/no-children-prop */}
          <code
            className={classnames(className, {
              hljs: !skipHighlighting
            })}
            dangerouslySetInnerHTML={skipHighlighting ? undefined : {__html: content}}
            children={skipHighlighting ? content : undefined}
          />
          {/* eslint-enable react/no-danger-with-children */}
          {/* eslint-enable react/no-children-prop */}
        </pre>
      );
    } else {
      return <code>{this.props.content}</code>;
    }
  }
}

export const codeBlock = Object.assign({}, SimpleMarkdown.defaultRules.codeBlock, {
  match: (source) => {
    return /^(?: {4}[^\n]+\n)+(?: *\n)+/.exec(source);
  },
  react(node) {
    return <Code block content={node.content} language={node.lang} key={node.tokenId} />;
  }
});

export const inlineCode = Object.assign({}, SimpleMarkdown.defaultRules.inlineCode, {
  react(node) {
    return <Code content={node.content} />;
  }
});

export const link = Object.assign({}, SimpleMarkdown.defaultRules.link, {
  react(node, output, state) {
    return (
      <Anchor
        as='a'
        href={SimpleMarkdown.sanitizeUrl(node.target)}
        rel='noopener noreferrer'
        title={node.title}
        target='_blank'
        key={node.tokenId}
      >
        {output(node.content, state)}
      </Anchor>
    );
  }
});

export const table = Object.assign({}, SimpleMarkdown.defaultRules.table, {
  react(node, output, state) {
    return (
      <div className='markdown-table-wrapper' key={node.tokenId}>
        {SimpleMarkdown.defaultRules.table.react(node, output, state)}
      </div>
    );
  }
});
